import { render, staticRenderFns } from "./WallpaperSharePage.vue?vue&type=template&id=27222cfe&scoped=true&"
import script from "./WallpaperSharePage.vue?vue&type=script&lang=js&"
export * from "./WallpaperSharePage.vue?vue&type=script&lang=js&"
import style0 from "./WallpaperSharePage.vue?vue&type=style&index=0&id=27222cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27222cfe",
  null
  
)

export default component.exports